import React, {useEffect, useState, Fragment} from "react";
import {connect, useSelector} from "react-redux";
import Alert from "./Alert";
import { logout } from "../../actions/auth";

export function Alerts(props) {

const messages = useSelector(state => state.messages);
const [authError, setAuthError] = useState(false);

useEffect(() => {
    // When messages update, see if any indicate an auth error
    (messages.filter(message => message.detail === "Invalid token.").length > 0) && setAuthError(true);
}, [messages])


useEffect(() => {
    // when an auth error is detected, trigger a logout and don't render the alert
    authError && props.logout();
}, [authError])

    return (
        <div className="alerts">
            {messages.map((message, index) => {
                return (
                    <Fragment key={message.id}>
                        {message.detail !== "Invalid token." && <Alert  message={message} />}
                    </Fragment>
                )
            })}

        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps, {logout})(Alerts);